/** Where the invite link should drop this person, or null to show the pitch page.
 *
 * The invite email link is the only route back into the portal, so /invite/<token>
 * receives first-time candidates and everyone returning for a second session. Only
 * the first group should be sold the product; returning candidates want home.
 *
 * `sessionId` is what marks someone as returning. Candidates re-authenticate with
 * the emailed code and nothing else: the password login and its forgotten-password
 * recovery were removed on 2026-09-05 (IC-270). Passwords were a second sign-in
 * method nothing routed to any more, and forgot+reset was a credential-minting
 * path guarded only by the invite token, which is a bearer credential.
 *
 * Returning candidates are NOT signed in automatically from the link. A cookie is
 * proof of a prior sign-in on THIS device; without it they authenticate again with
 * a fresh code. This is deliberate: anyone holding the link could reach the portal,
 * so a new device always re-proves identity against the candidate's own mailbox.
 */
export function returningRoute(data: {
  token: string;
  verified: boolean;
  sessionId: string | null;
}): string | null {
  const at = (screen: string) => `/invite/${data.token}/${screen}`;
  if (data.verified) return at("home");    // already signed in on this device
  if (data.sessionId) return at("verify"); // been here before: emailed code
  return null;                             // genuinely new: show the pitch
}
